import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-solutions-v2",
  templateUrl: "./solutions-v2.component.html",
  styleUrls: ["./solutions-v2.component.scss"],
})
export class SolutionsV2Component implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  solutions = [
    {
      image:
        "https://res.cloudinary.com/djqsg8e9k/image/upload/v1690318785/mb_lg_j9elw7.png",
      title: "Marihub Marketplace",
      description:
        "Experience a new era of procurement convenience on the high seas through our innovative provisions in the marine e-commerce marketplace. With advanced digital inventory systems and seamless delivery solutions, we ensure that delectable delights are just a click away.",
      link: "/solutions/marketplace",
    },
    // {
    //   image:
    //     "https://res.cloudinary.com/djqsg8e9k/image/upload/v1690318801/bp_lg_lj4pv6.png",
    //   title: "BluePass",
    //   description:
    //     "BluePass is an initiative is powered by Marihub and under patronage of the Ministry of Energy and Infrastructure (MOEI) in United Arab of Emirates",
    //   link: "/solutions/bluepass",
    // },
  ];
}
